import { Reveal, Overline } from "@/components/Reveal";
import { PROCESS, IMAGES } from "@/data";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="section-pad py-24 md:py-36">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4 lg:sticky lg:top-28 self-start">
          <Overline>The Healing Process</Overline>
          <Reveal>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-6 mb-8">
              A gentle, four-part journey inward.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-sans-ui text-[var(--muted-ink)] text-base leading-relaxed font-light mb-8">
              Every session follows a calm, considered rhythm — creating space to arrive, explore and integrate at your own pace.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative overflow-hidden clip-arch grain">
              <img src={IMAGES.studio} alt="Person standing in a large minimal window" className="w-full h-[320px] object-cover" />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-[rgba(200,149,54,0.3)]">
            {PROCESS.map((p, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div data-testid={`process-step-${i}`} className="group grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-10 md:py-12 items-start">
                  <span className="font-serif-display text-6xl md:text-8xl text-[rgba(200,149,54,0.35)] leading-none transition-colors duration-500 group-hover:text-[var(--gold)]">
                    {p.n}
                  </span>
                  <div className="pt-1 md:pt-3">
                    <h3 className="font-serif-display text-3xl md:text-4xl mb-3">{p.title}</h3>
                    <p className="font-sans-ui text-[var(--muted-ink)] text-base leading-relaxed font-light max-w-xl">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
